package com.pincer.core.rules

import com.pincer.core.functions.validateId
import com.pincer.core.InvalidData
import com.pincer.core.model.tree.Candidate

class IdealHeadcountRule(val headcount: Int): Rule() {

    override fun score(candidate: Candidate): Float {
        if (candidate.pt == null) {
            return MIGHT_BE_POSSIBLE
        }
        else {
            val candidateHeadcount = candidate.pt!!.split(",").size
            if (candidateHeadcount > headcount) {
                // TODO score lower for being over capacity
                return DEFINITELY_POSSIBLE
            }
            else {
                return candidateHeadcount.toFloat() / headcount.toFloat()
            }
        }
    }

    companion object {
        fun parse(params: List<String>): IdealHeadcountRule {
            if (params.size != 1) throw InvalidData("The IdealHeadcount rule needs exactly one parameter")
            try {
                val build = IdealHeadcountRule(params.first().toInt())
                if (build.headcount < 0) throw InvalidData("Headcount should be positive")
                return build
            }
            catch (nfe: NumberFormatException) { throw InvalidData("The number in the IdealHeadcount rule looks wrong") }
        }
    }

}

